import axios from "axios";
import { base_url, headers } from "../constants";

// ---------- Sign Up
export const signUp = async (body) => {
    try {
        const response = await axios.post(
            `${base_url}/api/v1/auth/signup`,
            body,
            {
                headers: {
                    ...headers,
                },
            }
        );

        return response?.status == 201
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        console.error("Signup error:", error);
        return {
            success: false,
            error: error?.response?.data?.response_message || "Signup failed",
        };
    }
};

// ---------- Login
export const login = async (body) => {
    try {
        const response = await axios.post(
            `${base_url}/api/v1/auth/login`,
            body,
            {
                headers: {
                    ...headers,
                },
            }
        );
        console.log(response)
        return response?.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        console.error("Login error:", error);
        return {
            success: false,
            error: error?.response?.data?.response_message || "Login failed",
        };
    }
};

// ---------- Verify Account
export const verify = async (body) => {
    try {
        const response = await axios.post(
            `${base_url}/api/v1/auth/verify-email`,
            body,
            {
                headers: {
                    ...headers,
                },
            }
        );

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        console.error("Login error:", error);
        return {
            success: false,
            error: error?.response?.data?.response_message || "Login failed",
        };
    }
};

// ---------- Forgot Password
export const forgotPassword = async (body) => {
    try {
        const response = await axios.post(
            `${base_url}/api/v1/auth/forgot-password`,
            body,
            {
                headers: {
                    ...headers,
                },
            }
        );
        console.log(response)
        return response?.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        console.error("Cannot Reset Password:", error);
        return {
            success: false,
            error: error?.response?.data?.response_message || "Password Reset failed",
        };
    }
};

// ---------- Reset Password
export const resetPassword = async (body) => {
    try {
        const response = await axios.post(
            `${base_url}/api/v1/auth/reset-password`,
            body,
            {
                headers: {
                    ...headers,
                },
            }
        );
        console.log(response)
        return response?.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        console.error("Cannot Reset Password:", error);
        return {
            success: false,
            error: error?.response?.data?.response_message || "Password Reset failed",
        };
    }
};

// ---------- About Me
export const userDetails = async () => {
  try {
    const token = sessionStorage.getItem("authToken");

    // No token → user is logged out
    if (!token) {
      return { success: false, authExpired: true };
    }

    const response = await axios.get(
      `${base_url}/api/v1/auth/me`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data?.response_status === "SUCCESS") {
      return {
        success: true,
        data: response.data.response_data,
      };
    }

    return { success: false };
  } catch (error) {
    //  Token expired / invalid
    if (error?.response?.status === 401) {
      return { success: false, authExpired: true };
    }

    console.error("User details error:", error);

    return {
      success: false,
      error:
        error?.response?.data?.response_message ||
        "Fetching user details failed",
    };
  }
};

// ---------- Refresh token
export const refreshToken = async () => {
  try {
    const refreshToken = sessionStorage.getItem("refreshToken");

    if (!refreshToken) {
      return { success: false, authExpired: true };
    }

    const response = await axios.post(
      `${base_url}/api/v1/auth/refresh-token`,
      {},
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${refreshToken}`,
        },
      }
    );

    if (response.data?.response_status === "SUCCESS") {
      const { jwt_token, refresh_token } = response.data.response_data;

      sessionStorage.setItem("authToken", jwt_token);
      sessionStorage.setItem("refreshToken", refresh_token);

      return { success: true };
    }

    return { success: false };
  } catch (error) {
    return { success: false, authExpired: true };
  }
};


